
let baseUrl = '';
//  图片url
let imgUrl = `${baseUrl}/download/image/`
export {
	baseUrl,
	imgUrl
}